import React, { useEffect, useState } from 'react';
import { GetTCards_GetItems } from '../../../Core/Service/T-card-services';
import { Button, Grid, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Checkbox, CircularProgress } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/styles';
import { SecondaryButton } from '../../../Core/FormInput';
import formatters from '../../../Core/Grid/inputFormatter';

const useStyles = makeStyles((theme) => ({
    root: { marginTop: 15 },
    table: { minWidth: 950 },
    tableContainer: {
        height: 300,
        border: '1px solid rgba(0,0,0,0.2)'
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center'
    }
}));

const StyledTableRow = withStyles(() => ({
    root: { cursor: 'pointer' }
}))(TableRow);

const StyledTableCell = withStyles(() => ({
    head: {
        fontSize: 15,
        fontWeight: 600,
        backgroundColor: '#bdbdbd82',
        padding: '6px 8px'
    },
    body: {
        fontSize: 14,
        padding: '6px 8px'
    }
}))(TableCell);

const ImportTCardTable = ({ tCardsID, onSubmitImportTCardListHandler }) => {
    const classes = useStyles();
    const [tCardLineItems, setTCardLineItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isAllSelect, setIsAllSelect] = useState(false);

    useEffect(() => {
        const fetchTCardItems = async () => {
            setLoading(true);
            try {
                const res = await GetTCards_GetItems(tCardsID);
                setTCardLineItems(res.data.tCards || []);
            } finally {
                setLoading(false);
            }
        };
        fetchTCardItems();
    }, [tCardsID]);

    const onJobSelect = (checked, tCardsLineItemsID) => {
        setTCardLineItems((prevItems) => prevItems.map((item) => (item.tCardsLineItemsID === tCardsLineItemsID ? { ...item, isSelected: checked } : item)));
    };

    const onJobAllSelect = (e) => {
        setIsAllSelect(e.target.checked);
        setTCardLineItems((prevItems) => prevItems.map((item) => ({ ...item, isSelected: e.target.checked })));
    };

    const handleSubmit = () => {
        onSubmitImportTCardListHandler(tCardLineItems.filter((q) => q.isSelected));
    };

    return (
        <Grid container spacing={2} alignItems="center" justifyContent="center">
            {loading ? (
                <Grid item xs={12} style={{ height: '300px', textAlign: 'center' }}>
                    <CircularProgress />
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <TableContainer className={classes.tableContainer}>
                        <Table className={classes.table} size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell width="5%">
                                        <Checkbox nmae="isAllSelect" checked={isAllSelect || false} color="primary" onChange={onJobAllSelect} />
                                    </StyledTableCell>
                                    <StyledTableCell width="25%">Description/Comments</StyledTableCell>
                                    <StyledTableCell width="25%">Cause</StyledTableCell>
                                    <StyledTableCell width="25%">Cure</StyledTableCell>
                                    <StyledTableCell width="10%">Event Type</StyledTableCell>
                                    <StyledTableCell width="10%">Due Date</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tCardLineItems.map((q) => (
                                    <StyledTableRow key={q.tCardsLineItemsID}>
                                        <StyledTableCell>
                                            <Checkbox
                                                checked={q.isSelected || false}
                                                color="primary"
                                                onChange={(e) => onJobSelect(e.target.checked, q.tCardsLineItemsID)}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>{q.tCardsLineItemsDescription}</StyledTableCell>
                                        <StyledTableCell>{q.cause}</StyledTableCell>
                                        <StyledTableCell>{q.cure}</StyledTableCell>
                                        <StyledTableCell>{q.event}</StyledTableCell>
                                        <StyledTableCell>{formatters.YearFormatter(q.tCardsLineItemsDueDate)}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            )}
            <Grid item xs={12}>
                <SecondaryButton fullWidth onClick={handleSubmit} disabled={tCardLineItems.filter((q) => q.isSelected).length <= 0 || loading}>
                    Submit
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default ImportTCardTable;
